import React from 'react';
import { createPortal } from 'react-dom';
import { Row } from '@/lib/utils';
import { MediumText } from '@/lib/Text';
import SvgIcon from '@/components/SvgIcon';

/**
 * 요율 모달 위에 뜨는 작은 대화상자 틀. CopyFromPrevMonthDialog 와 같은 모양(z-[99998])을
 * body 포털로 띄운다 — 부모 모달 안 스크롤·overflow 에 잘리지 않게.
 */
const DialogShell = ({
    title,
    width = 560,
    onClose,
    busy = false,
    children,
}: {
    title: string;
    width?: number;
    onClose: () => void;
    busy?: boolean;
    children: React.ReactNode;
}) =>
    createPortal(
        <div
            className="fixed inset-0 z-[99998] bg-black/30 flex items-center justify-center"
            onMouseDown={(e) => {
                if (e.currentTarget === e.target && !busy) onClose();
            }}
        >
            <div
                className="bg-white rounded-[20px] shadow-lg max-h-[86vh] flex flex-col"
                style={{ width }}
                onMouseDown={(e) => e.stopPropagation()}
            >
                <Row className="items-center justify-between px-[24px] pt-[22px] pb-[4px]">
                    <MediumText fontSize={19} color="#1A1A1A">
                        {title}
                    </MediumText>
                    <div className="cursor-pointer p-[6px]" onClick={busy ? undefined : onClose}>
                        <SvgIcon name="SvgX" size={14} stroke="#6B7280" strokeWidth={2} />
                    </div>
                </Row>
                {children}
            </div>
        </div>,
        document.body,
    );

export default DialogShell;
